<template>
  <div class="resourceApp__results">
    <div
      v-if="isDataAvailable && entries.length === 0"
      class="trResults__noResults"
    >
      <span class="trResults__noResultsTitle">Sorry, no results found.</span>
      <p>Search tips:</p>
      <ul>
        <li>Double check your spelling</li>
        <li>Search again using different words</li>
        <li>Remove your filters</li>
      </ul>
    </div>
    <div v-if="error" class="trResults__noResults">
      Sorry, an error has occured. Please try a different search or refresh the
      page.
    </div>
    <transition-group name="fade" tag="div" class="resources" v-cloak>
      <loading-indicator :key="-1" v-if="showTopSpinner"></loading-indicator>
      <resource
        v-for="entry in entries"
        v-bind:entry="entry"
        :key="entry.id"
        v-on:tag-clicked="tagClicked($event)"
      ></resource>
      <loading-indicator :key="0" v-if="showBottomSpinner"></loading-indicator>
    </transition-group>
    <button
      v-if="showLoadMore && enableLoadMore"
      class="button button--primary button--center"
      id="blogExtra__loadMoreButton"
      @click="loadMore"
      v-cloak
    >
      {{ loadMoreText }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import loading from "./sub-components/loading";
import resource from "./resource";
import ajaxErrorHandling from "./mixins/ajaxErrorHandling";
import "@babel/polyfill";

const CancelToken = axios.CancelToken;
let cancel = false;

export default {
  name: "resources",
  mixins: [ajaxErrorHandling],
  props: {
    elementsPerPage: {
      type: Number,
      default: 100,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    ids: {
      type: Array,
      default: () => [],
    },
    loadMoreText: {
      type: String,
      default: "Load More",
    },
    enableLoadMore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTopSpinner: true,
      showBottomSpinner: false,
      showLoadMore: false,
      totalResults: null,
      entries: [],
      isDataAvailable: false,
      error: null,
      nextQuery: null,
    };
  },
  components: {
    "loading-indicator": loading,
    resource: resource,
  },
  mounted: function () {
    this.getEntries(null, false, this.filters.length === 0);
  },
  watch: {
    filters: {
      handler(val) {
        if (cancel) cancel();
        this.getEntries();
      },
      deep: true,
    },
  },
  methods: {
    async getEntries(url = false, append = false, random = false) {
      try {
        if (append) this.showBottomSpinner = true;
        else this.showTopSpinner = true;
        this.showLoadMore = false;
        let restURL = url;
        let params = {};
        if (!url) {
          restURL = "/api/resources.json";
          params = {
            pg: 1,
            elementsPerPage: this.elementsPerPage,
            categoryFilters: this.filters,
            ids: [...new Set(this.ids)],
            random: random,
          };
        }

        const response = await axios.get(restURL, {
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          }),
          params: params,
        });

        //console.log(response.data);

        if (Array.isArray(response.data.data)) {
          cancel = false;

          if (append) {
            this.entries = this.entries.concat(response.data.data);
            this.showBottomSpinner = false;

            //enable smooth scrolling
            const html = document.getElementsByTagName("html")[0];
            html.classList.add("u-smoothScroll");

            //set focus to first newly added entry
            this.$nextTick(() => {
              const newestId = response.data.data[0].id;
              window.location.hash = "#tr-" + newestId;

              setTimeout(function () {
                html.classList.remove("u-smoothScroll");
              }, 500);
            });
          } else {
            this.entries = response.data.data;
            this.showTopSpinner = false;
          }
          this.isDataAvailable = true;

          const pagination = response.data.meta.pagination;
          this.$emit("update-results-count", pagination.total);
          this.totalResults = pagination.total;
          const curPage =
            pagination.current_page === 0 ? 1 : pagination.current_page;
          if (pagination.links) this.nextQuery = pagination.links.next ?? null;
          this.showLoadMore = curPage < pagination.total_pages;
        } else {
          //error handling if bad request
          this.error = true;
          this.showTopSpinner = false;
          this.showBottomSpinner = false;
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          this.error = true;
          this.showTopSpinner = false;
          this.showBottomSpinner = false;
          this.axiosErrorOutput(error);
        }
      }
    },
    loadMore: function () {
      this.showSpinner = true;
      this.showLoadMore = false;
      this.getEntries(this.nextQuery, true);
    },
    tagClicked(tag) {
      this.$emit("tag-clicked", tag);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/variables";

.resourceApp__selectedFilters {
  margin-block-start: 1em;
}
.tr {
  .resourceApp__selectedFilters {
    margin-block-start: 0em;
  }
}

.trResults__noResults {
  font-weight: $bold-weight;
  p {
    font-size: $base-font-size;
  }
}
.trResults__noResultsTitle {
  font-size: $heading-size--h3;
}
</style>
